import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('howie_service_area', '/howie_service_areas')
const actions = generator.generate()

export default actions
